/* eslint-disable @typescript-eslint/no-explicit-any, camelcase */

/**
 * This file is autogenerated, please don't edit it manually.
 * Use this command to regenerate it if you modified Epic experiments:
 * yarn epic:types
 */

/**
 * Epic experiments namespaces with their possible keys.
 * Autogenerated from static/bundles/epic/data/defaults/
 */
import client from 'bundles/epic/client';
import search from 'bundles/epic/data/defaults/search.json';
import type { Tags } from 'bundles/epic/lib/EpicTypes';

type Namespace = {
  enableSearchExplainer: boolean;
  suggestionsSearchEngine: 'ALGOLIA' | 'OPENSEARCH';
  consumerProductsSearchHeavyRanker:
    | 'rt-search-heavy-ranker-content-mix-index-enrichment-prod'
    | 'rt-search-heavy-ranker-content-mix-index-enrichment-feat-prod';
  languageModeClarity: boolean;
  freeQuery: boolean;
  serpFilterVariant: boolean;
  autoApplyFilters: boolean;
  eqpFilterVariant: boolean;
  browseFilterVariant: boolean;
  eqpAutoApplyFilters: boolean;
  showNewAutocomplete: boolean;
  streamAISummary: boolean;
  aiSummaryProductCards: boolean;
};

const NAMESPACE = 'search';

// Adding safe optional chaining to avoid massive changes in unit tests.
client.addDefaults?.([search as $TSFixMe]);

const searchEpicClient = {
  get<K extends keyof Namespace>(key: K, tags?: Tags): Namespace[K] {
    return client.get(NAMESPACE, key, tags);
  },

  preview<K extends keyof Namespace>(key: K, tags?: Tags, defaults?: Namespace): Namespace[K] {
    return client.preview(NAMESPACE, key, tags);
  },
};

export default searchEpicClient;
